import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Section } from './ui/Section';
interface Testimonial {
  initials: string;
  name: string;
  role: string;
  quote: string;
  avatar?: string;
}
interface TestimonialsProps {
  title?: string;
  subtitle?: string;
  testimonials: Testimonial[];
  background?: 'cream' | 'white' | 'celeste';
}
export const Testimonials: React.FC<TestimonialsProps> = ({
  title,
  subtitle,
  testimonials,
  background = 'cream'
}) => {
  return <Section background={background} data-id="element-352">
      {(title || subtitle) && <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-353">
          {subtitle && <p className="text-celeste-600 font-bold tracking-wide uppercase text-sm mb-2" data-id="element-354">
              {subtitle}
            </p>}
          {title && <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900" data-id="element-355">
              {title}
            </h2>}
        </div>}

      <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-356">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-100 flex flex-col h-full relative" data-id="element-357">
            <div className="flex text-yellow-400 mb-4" data-id="element-358">
              {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-current" data-id="element-359" />)}
            </div>
            <blockquote className="text-stone-700 mb-6 flex-grow font-medium leading-relaxed" data-id="element-360">
              "{t.quote}"
            </blockquote>
            <div className="flex items-center gap-3 mt-auto pt-4 border-t border-stone-50" data-id="element-361">
              {t.avatar ? <img src={t.avatar} alt={`Foto de ${t.name}, maestra del Tramo 2`} className="w-10 h-10 rounded-full object-cover shrink-0 ring-2 ring-celeste-100" loading="lazy" data-id="element-362" /> : <div className="w-10 h-10 rounded-full bg-celeste-100 text-celeste-700 flex items-center justify-center font-bold text-sm shrink-0" data-id="element-363">
                  {t.initials}
                </div>}
              <div data-id="element-364">
                <div className="font-bold text-stone-900 text-sm" data-id="element-365">{t.name}</div>
                <div className="text-xs text-stone-500" data-id="element-366">{t.role}</div>
              </div>
            </div>
          </motion.div>)}
      </div>
    </Section>;
};
export const FirstTestimonials = () => {
  const data = [{
    initials: 'MG',
    name: 'Mariela G.',
    role: 'Maestra Tramo 2 · Montevideo',
    quote: 'Organicé todo el año de Historia y Geografía en una tarde. Las fichas listas me ahorran horas cada semana. Nunca más llego al lunes sin saber qué dar.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    role: 'Maestra · Escuela Pública · Canelones',
    quote: 'Por fin tengo material de Ciudadanía alineado al EBI de verdad. Las rúbricas son lo que más necesitaba y nunca encontraba en ningún lado.'
  }, {
    initials: 'RM',
    name: 'Rosa M.',
    role: 'Maestra de Aula · Salto',
    quote: 'Mis clases de Física y Química por fin tienen secuencia y sentido. El Tomo 1 vale cada peso que pagué.'
  }];
  return <Testimonials title="LAS PRIMERAS MAESTRAS YA LO TIENEN" testimonials={data} background="cream" data-id="element-367" />;
};